import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    padding: spacing(0, 3, 3)
  },
  contentContainer: {
    padding: spacing(3, 0)
  },
  sectionAccordion: {
    marginBottom: spacing(1),
    '&:before': {
      display: 'none'
    },
    '&.Mui-expanded': {
      margin: '0 0 8px 0 !important'
    }
  },
  accordionSummary: {
    backgroundColor: palette.white?.main || palette.background?.paper,
    borderRadius: '4px 4px 0 0',
    minHeight: 56,
    '&.Mui-expanded': {
      minHeight: 56
    }
  },
  accordionDetails: {
    padding: spacing(3),
    backgroundColor: palette.white?.main || palette.background?.default,
    borderRadius: '0 0 4px 4px'
  },
  imagePreview: {
    padding: spacing(2),
    backgroundColor: palette.background?.paper || '#fff',
    borderRadius: 4,
    border: `1px solid ${palette.divider || '#e0e0e0'}`
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: 200,
    objectFit: 'contain',
    borderRadius: 4
  },
  tenantInfo: {
    marginTop: spacing(4),
    padding: spacing(2),
    backgroundColor: palette.grey?.light || '#f5f5f5',
    borderRadius: 4,
    textAlign: 'center'
  },
  bannerContainer: {
    padding: spacing(3),
    backgroundColor: palette.background?.paper || '#fff',
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    borderRadius: 8,
    marginBottom: spacing(2)
  },
  bannerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(4),
    paddingBottom: spacing(2),
    borderBottom: `1px solid ${palette.divider || '#e0e0e0'}`
  },
  addBannerContainer: {
    textAlign: 'center',
    padding: spacing(2),
    backgroundColor: palette.grey?.light || '#f5f5f5',
    borderRadius: 4,
    border: `2px dashed ${palette.divider || '#e0e0e0'}`
  }
}))
